import { types } from "../types/types";
const intitalState = {
    allAuthors: [],
};

const authorReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_AUTHORS:
            return {
                ...state,
                allAuthors: action.payload,
            };
        default:
            return { ...state };
    }
};

export default authorReducer;
